import i18n from '~/components/i18n'

export function getNumberOfFeeds(feeds) {
  let sum = 0
  Object.keys(feeds).map(key => {
    if (key === 'coarseFeeds' || key === 'juicyFeeds' || key === 'concentratedFeeds') {
      sum += Object.values(feeds[key]).length
    }
  })
  return sum
}

export function getNumberOfFilledFeeds(feeds) {
  let sum = 0
  Object.keys(feeds).map(key => {
    if (key === 'coarseFeeds' || key === 'juicyFeeds' || key === 'concentratedFeeds') {
      sum += Object.values(feeds[key]).filter(feed => !!feed['value']).length
    }
  })
  return sum
}

export function findJuicyFeed(feeds) {
  const feedGroupWithJuicyFeed = feeds.find(group => group.juicyFeeds && group.juicyFeeds.length > 0);

  // Return the first juicyFeed found, or null if none exists
  if (feedGroupWithJuicyFeed) {
    return feedGroupWithJuicyFeed.juicyFeeds[0];
  }

  return null;
}

export function totalJuicyFeedsSelected(feedGroups) {
  return feedGroups.reduce((previousJuicyFeedsCount, feedGroup) => {
    previousJuicyFeedsCount += feedGroup.juicyFeeds.length
    return previousJuicyFeedsCount
  }, 0)
}

export function getSumOfFilledFeeds(feeds) {
  let sum = 0
  Object.keys(feeds).map(key => {
    if (key === 'coarseFeeds' || key === 'juicyFeeds' || key === 'concentratedFeeds') {
      const feedsSum = feeds[key].reduce((previosValue, currentValue) => {
        if (currentValue.value && Boolean(currentValue.value)) {
          previosValue = previosValue + parseFloat(currentValue.value.replace(',', '.'))
          return previosValue
        }
        return previosValue
      }, 0) || 0
      sum = sum + feedsSum
    }
  })
  return sum
}

export function redistributeDays(feedGroups, calfRearingDays) {
  // Target calf days
  const targetDays = calfRearingDays;
  // Step 1: Calculate initial rounded days and remainders
  let totalRoundedDays = 0;
  const remainders = [];

  feedGroups.forEach(group => {
    const roundedDays = Math.floor(group.days); // Floor value to nearest integer
    totalRoundedDays += roundedDays; // Accumulate total rounded days
    remainders.push({ index: feedGroups.indexOf(group), remainder: group.days - roundedDays }); // Track index and remainder
    group.days = roundedDays; // Update feedGroups directly by flooring the days
  });

  // Step 2: Calculate the difference between target days and rounded total
  const daysToDistribute = targetDays - totalRoundedDays;
  
  // Step 3: Sort remainders in descending order to distribute missing days
  if (daysToDistribute > 0) {
    // Sort by largest remainders to distribute missing days
    remainders.sort((a, b) => b.remainder - a.remainder);
    for (let i = 0; i < daysToDistribute; i++) {
      // Update the feedGroups directly by incrementing the 'days' value
      feedGroups[remainders[i].index].days += 1;
    }
  } else if (daysToDistribute < 0) {
    // Sort by smallest remainders to subtract excess days
    remainders.sort((a, b) => a.remainder - b.remainder);
    for (let i = 0; i < Math.abs(daysToDistribute); i++) {
      // Update the feedGroups directly by decrementing the 'days' value
      feedGroups[remainders[i].index].days -= 1;
    }
  }
  return feedGroups
}

export function redistributeCattleNumbers(feedGroups, cattleNumber) {
  const currentTotal = feedGroups.reduce((sum, fg) => sum + fg.cattleNumber, 0);
  const totalCattleNumber = parseInt(cattleNumber?.toString().replace(',', '.'))

  const proportional = feedGroups.map(fg => ({
    ...fg,
    raw: (fg.cattleNumber / currentTotal) * totalCattleNumber
  }));

  const withFloor = proportional.map(fg => ({
    ...fg,
    cattleNumber: Math.floor(fg.raw)
  }));

  const remainder = totalCattleNumber - withFloor.reduce((sum, fg) => sum + fg.cattleNumber, 0);

  const sortedByFraction = [...withFloor].sort((a, b) =>
    (b.raw - b.cattleNumber) - (a.raw - a.cattleNumber)
  );

  for (let i = 0; i < remainder; i++) {
    sortedByFraction[i].cattleNumber += 1;
  }

  const final = feedGroups.map(fg =>
    sortedByFraction.find(s => s.name === fg.name)!
  );
  
  return final;
}

function phaseFeedingDataParse(feedingPhases) {
  feedingPhases.forEach(feedingPhase => {
    feedingPhase.coarseFeeds.forEach(feed => {
      feed.value = feed.value?.replace(',', '.');
    });
    feedingPhase.concentratedFeeds.forEach(feed => {
      feed.value = feed.value?.replace(',', '.');
    });
    feedingPhase.juicyFeeds.forEach(feed => {
      feed.value = feed.value?.replace(',', '.');
    });
  });
  return feedingPhases
}

export function prepareDataForPayload(data) {
  Object.keys(data).forEach(key => {
    if (typeof data[key] === 'string') {
      data[key] = data[key].replace(',', '.');
    } else if (key === 'feedGroups') {
      data.feedGroups.forEach(feedGroup => {
        if (feedGroup.feedingPhases?.length > 0) {
          feedGroup.feedingPhases = phaseFeedingDataParse(feedGroup.feedingPhases)
        } else {
          feedGroup?.coarseFeeds?.forEach(feed => {
            feed.value = feed.value?.replace(',', '.');
          });
          feedGroup?.concentratedFeeds?.forEach(feed => {
            feed.value = feed.value?.replace(',', '.');
          });
          feedGroup?.juicyFeeds?.forEach(feed => {
            feed.value = feed.value?.replace(',', '.');
          });
        }
      });
    } else if (['energyConsumptions', 'manureStorageTypes'].includes(key)) {
      data[key].forEach(item => {
        item.percent = item.percent.replace(',', '.');
      });
    } else if (['coarseFeeds', 'concentratedFeeds', 'juicyFeeds'].includes(key)) {
      data[key].forEach(item => {
        item.dryMatter = item.dryMatter.replace(',', '.');
        item.energy = item.energy.replace(',', '.');
      });
    }
  });
  return data
}

export function getTransformFeedGroups(feeds) {
  const feedsTransformed = []
  feeds.map((feedGroup, index) => {
    if (feedGroup['feedingPhases'] && feedGroup['feedingPhases']?.length > 0) {
      feedGroup['feedingPhases'].map(feedPhase => {
        const feedGroupTitle = feedGroup['name']
        const title = i18n.t('{{feedTitle}} / {{phaseTitle}}', { feedTitle: feedGroupTitle, phaseTitle: feedPhase.name })
        feedsTransformed.push({ ...feedPhase, feedGroupIndex: index, name: title })
      })
    } else {
      feedsTransformed.push({ ...feedGroup, feedGroupIndex: index })
    }
  })
  return feedsTransformed
}